interface CardPositionIndicatorProps {
  total: number;
  current: number;
}

export function CardPositionIndicator({ total, current }: CardPositionIndicatorProps) {
  if (total <= 1) return null;

  return (
    <div
      role="status"
      aria-label={`Item ${String(current + 1)} of ${String(total)}`}
      style={{
        display: 'flex',
        gap: 'var(--space-xs)',
        justifyContent: 'center',
        margin: 'var(--space-md) 0',
      }}
    >
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor:
              i === current ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
            transition: 'background-color var(--transition-fast)',
          }}
        />
      ))}
    </div>
  );
}
